<template>
  <div class="content">

    <!-- Botón nuevo producto (patrón de la app) -->
    <div class="col-md-12 d-flex justify-content-end mb-3 px-0">
      <button class="btn btn-success" @click="openCreateDialog()">
        <i class="material-icons" style="font-size:16px;vertical-align:middle;margin-right:4px;">add</i>
        Nuevo Producto
      </button>
    </div>

    <!-- Stats -->
    <v-row class="mb-3">
      <v-col cols="12" sm="4">
        <div class="stat-card">
          <div class="stat-icon stat-icon--primary">
            <v-icon size="22" style="color:#fff!important;">mdi-package-variant</v-icon>
          </div>
          <div>
            <div class="stat-value" style="color:#1976d2;">{{ pagination.total }}</div>
            <div class="stat-label">Total productos</div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <div class="stat-card">
          <div class="stat-icon stat-icon--indigo">
            <v-icon size="22" style="color:#fff!important;">mdi-earth</v-icon>
          </div>
          <div>
            <div class="stat-value" style="color:#3949ab;">{{ globalCount }}</div>
            <div class="stat-label">Globales</div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <div class="stat-card">
          <div class="stat-icon stat-icon--teal">
            <v-icon size="22" style="color:#fff!important;">mdi-domain</v-icon>
          </div>
          <div>
            <div class="stat-value" style="color:#00796b;">{{ localCount }}</div>
            <div class="stat-label">De esta cuenta</div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Card principal (patrón de la app) -->
    <div class="card">
      <div class="card-header card-header-success">
        <h4 class="card-title">Productos</h4>
      </div>
      <div class="card-body">

        <!-- Error -->
        <v-alert v-if="errored" border="left" color="error" text class="mb-3">
          No es posible obtener la información en este momento.
        </v-alert>

        <template v-else>
          <!-- Filtros -->
          <v-row class="mb-3" align="center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="filters.nombre"
                label="Buscar por nombre"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                hide-details
                clearable
                @input="debouncedGetItems"
                @click:clear="clearFilter('nombre')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="filters.codigo_sku"
                label="Buscar por SKU"
                prepend-inner-icon="mdi-barcode-scan"
                outlined
                dense
                hide-details
                clearable
                @input="debouncedGetItems"
                @click:clear="clearFilter('codigo_sku')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="d-flex align-center" style="gap:8px;">
              <span style="font-size:0.8rem;color:#666;">Alcance:</span>
              <div class="alcance-group">
                <button
                  v-for="op in alcanceOpciones" :key="op.value"
                  :class="['alcance-btn', alcanceFiltro === op.value ? 'alcance-btn--active' : '']"
                  @click="alcanceFiltro = op.value"
                >{{ op.label }}</button>
              </div>
            </v-col>
          </v-row>

          <!-- Tabla -->
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :loading="loading"
            :items-per-page="options.itemsPerPage"
            loading-text="Cargando productos..."
            no-data-text=""
            hide-default-footer
            class="products-table"
          >
            <template v-slot:no-data>
              <div class="py-8 text-center">
                <v-icon size="48" color="grey lighten-2">mdi-package-variant-closed</v-icon>
                <p class="grey--text mt-2 mb-3">No hay productos para mostrar.</p>
                <button class="btn btn-success btn-sm" @click="openCreateDialog()">+ Crear producto</button>
              </div>
            </template>

            <template v-slot:[`item.nombre`]="{ item }">
              <div class="d-flex align-center py-1" style="width:100%;">
                <div :class="['row-icon', item.cuenta_id === 0 ? 'row-icon--global' : 'row-icon--local']">
                  <v-icon size="14" style="color:#fff!important;">{{ item.cuenta_id === 0 ? 'mdi-earth' : 'mdi-domain' }}</v-icon>
                </div>
                <div class="ml-2" style="flex:1 1 auto; min-width:0;">
                  <div class="font-weight-medium" style="font-size:0.875rem;">{{ item.nombre }}</div>
                </div>
              </div>
            </template>

            <template v-slot:[`item.alcance`]="{ item }">
              <span :class="['badge-alcance', item.cuenta_id === 0 ? 'badge-alcance--global' : 'badge-alcance--local']">
                {{ item.cuenta_id === 0 ? 'Global' : 'Esta cuenta' }}
              </span>
            </template>

            <template v-slot:[`item.precio_costo`]="{ item }">
              <span style="color:#757575;font-size:0.875rem;">{{ formatCurrency(item.precio_costo) }}</span>
            </template>

            <template v-slot:[`item.precio_venta`]="{ item }">
              <strong style="font-size:0.875rem;">{{ formatCurrency(item.precio_venta) }}</strong>
            </template>
            <template v-slot:[`item.activo`]="{ item }">
                <v-chip
                  small
                  :style="item.activo
                    ? 'background-color:#4caf50 !important; color:#fff !important;'
                    : 'background-color:#f44336 !important; color:#fff !important;'"
                >
                  {{ item.activo ? 'Activo' : 'Inactivo' }}
                </v-chip>
            </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small class="mr-2" v-bind="attrs" v-on="on" @click="toggleActivo(item)">
                        <v-icon small :style="item.activo ? 'color:#4caf50 !important;' : 'color:#757575 !important;'">
                          {{ item.activo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.activo ? 'Desactivar' : 'Activar' }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" @click="deleteItem(item)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                     <span>Eliminar</span>
                  </v-tooltip>
                </template>
            <template v-slot:footer>
              <v-divider></v-divider>
              <div class="d-flex align-center justify-space-between flex-wrap pa-2" style="gap:8px;">
                <div class="d-flex align-center">
                  <span class="text-caption grey--text mr-1">Filas:</span>
                  <v-menu top :close-on-content-click="true">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text x-small color="primary" v-bind="attrs" v-on="on">
                        {{ options.itemsPerPage }}<v-icon right x-small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item v-for="n in rowsPerPageArray" :key="n" @click="updateRowsPerPage(n)">
                        <v-list-item-title>{{ n }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <span class="text-caption grey--text">{{ pagination.total }} resultado{{ pagination.total !== 1 ? 's' : '' }}</span>
                <v-pagination
                  v-model="pagination.page"
                  :length="pagination.lastPage"
                  :total-visible="5"
                  @input="onPageChange"
                  circle small
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </template>
      </div>
    </div>

    <!-- Create / Edit Dialog -->
    <v-dialog v-model="createDialog" persistent max-width="540px">
      <v-card class="rounded-lg">

        <!-- Dialog Header -->
        <div :class="['dialog-header', editing ? 'dialog-header--edit' : 'dialog-header--create']">
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <div class="dialog-icon mr-3">
                <v-icon color="white">{{ editing ? 'mdi-pencil' : 'mdi-plus-circle-outline' }}</v-icon>
              </div>
              <div>
                <div class="white--text font-weight-bold text-body-1">
                  {{ editing ? 'Editar Producto' : 'Nuevo Producto' }}
                </div>
                <div class="white--text text-caption" style="opacity: 0.8;">
                  {{ editing ? 'Modificá los datos del producto' : 'Completá los datos del nuevo producto' }}
                </div>
              </div>
            </div>
            <v-btn icon dark small @click="closeCreateDialog()">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <div v-if="processing">
          <loader
            object="#4caf50"
            color1="#ffffff"
            color2="#17fd3d"
            size="5"
            speed="2"
            bg="#343a40"
            objectbg="#999793"
            opacity="40"
            disableScrolling="false"
            name="box"
          ></loader>
        </div>

        <v-card-text class="pa-5">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="saveItem">

            <!-- Alcance -->
            <div class="mb-4">
              <div class="field-section-label mb-2">Alcance</div>
              <v-card
                outlined
                class="scope-card pa-3"
                :class="editedItem.para_todas_cuentas ? 'scope-card--global' : 'scope-card--local'"
              >
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div :class="['scope-icon', editedItem.para_todas_cuentas ? 'scope-icon--global' : 'scope-icon--local']" class="mr-3">
                      <v-icon size="16" style="color:#fff!important;">{{ editedItem.para_todas_cuentas ? 'mdi-earth' : 'mdi-domain' }}</v-icon>
                    </div>
                    <div>
                      <div class="text-body-2 font-weight-medium">
                        {{ editedItem.para_todas_cuentas ? 'Todas las cuentas' : 'Solo esta cuenta' }}
                      </div>
                      <div class="text-caption grey--text">
                        {{
                          editedItem.para_todas_cuentas
                            ? 'El producto estará disponible para todas las cuentas'
                            : 'El producto es exclusivo de esta cuenta'
                        }}
                      </div>
                    </div>
                  </div>
                  <v-switch
                    v-model="editedItem.para_todas_cuentas"
                    :color="editedItem.para_todas_cuentas ? 'indigo darken-1' : 'teal darken-1'"
                    hide-details
                    inset
                    class="mt-0 pt-0 ml-2"
                  ></v-switch>
                </div>
              </v-card>
            </div>

            <!-- Info general -->
            <div class="field-section-label mb-3">Información general</div>
            <v-text-field
              v-model="editedItem.nombre"
              label="Nombre del producto *"
              :rules="[v => !!v || 'El nombre es requerido']"
              required
              outlined
              dense
              prepend-inner-icon="mdi-tag-outline"
              class="mb-2"
              validate-on-blur
            ></v-text-field>
            <v-text-field
              v-model="editedItem.codigo_sku"
              label="Código SKU"
              placeholder="Ej: PROD-001"
              outlined
              dense
              prepend-inner-icon="mdi-barcode"
            ></v-text-field>

            <v-divider class="my-4"></v-divider>

            <!-- Precios -->
            <div class="field-section-label mb-3">
              <v-icon x-small class="mr-1" style="vertical-align: middle;">mdi-cash-multiple</v-icon>
              Precios
            </div>
            <v-row no-gutters>
              <v-col cols="6" class="pr-2">
                <v-text-field
                  v-model="priceCostInput"
                  label="Precio costo"
                  prefix="$"
                  outlined
                  dense
                  prepend-inner-icon="mdi-cart-outline"
                  hint="Opcional"
                  persistent-hint
                  @input="onPriceInput($event, 'precio_costo')"
                  @blur="formatOnBlur('precio_costo')"
                  @keypress="isNumberOrComma"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pl-2">
                <v-text-field
                  v-model="priceSaleInput"
                  label="Precio venta *"
                  prefix="$"
                  :rules="[v => !!v || 'El precio de venta es requerido']"
                  required
                  outlined
                  dense
                  validate-on-blur
                  prepend-inner-icon="mdi-cash-register"
                  @input="onPriceInput($event, 'precio_venta')"
                  @blur="formatOnBlur('precio_venta')"
                  @keypress="isNumberOrComma"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Margen -->
            <v-expand-transition>
              <v-card
                v-if="editedItem.precio_venta > 0 && editedItem.precio_costo > 0"
                outlined
                rounded="lg"
                class="margin-card pa-3"
              >
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon
                      small
                      :color="profitMargin >= 0 ? 'success' : 'warning'"
                      class="mr-2"
                    >
                      {{ profitMargin >= 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}
                    </v-icon>
                    <span class="text-body-2 grey--text">Margen de ganancia</span>
                  </div>
                  <div class="text-right">
                    <span
                      class="font-weight-bold text-body-2"
                      :class="profitMargin >= 0 ? 'success--text' : 'warning--text'"
                    >
                      {{ profitMargin.toFixed(1) }}%
                    </span>
                    <span class="text-caption grey--text ml-2">
                      ({{ formatCurrency(editedItem.precio_venta - editedItem.precio_costo) }})
                    </span>
                  </div>
                </div>
              </v-card>
            </v-expand-transition>

          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <span class="text-caption red--text">* Obligatorio</span>
          <v-spacer></v-spacer>
          <v-btn text small @click="closeCreateDialog()" class="mr-2">Cancelar</v-btn>
          <v-btn color="primary" depressed small :disabled="!valid" @click="saveItem()">
            <v-icon left x-small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { Productos } from "../../services/productos.js";
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";

export default {
  name: "Productos",
  data: () => ({
    loading: false,
    createDialog: false,
    errored: false,
    processing: false,
    valid: false,
    editing: false,
    alcanceFiltro: "todos",
    alcanceOpciones: [
      { value: "todos",  label: "Todos"     },
      { value: "global", label: "Global"    },
      { value: "cuenta", label: "Mi cuenta" },
    ],

    priceCostInput: "",
    priceSaleInput: "",

    filters: {
      nombre: "",
      codigo_sku: ""
    },

    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "SKU", value: "codigo_sku" },
      { text: "Precio Costo", value: "precio_costo" },
      { text: "Precio Venta", value: "precio_venta" },
      { text: "Estado", value: "activo", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    items: [],

    pagination: {
      page: 1,
      lastPage: 1,
      total: 0
    },
    options: {
      itemsPerPage: 10
    },
    rowsPerPageArray: [10, 25, 50],

    editedItem: {
      id: null,
      nombre: "",
      codigo_sku: "",
      precio_costo: 0,
      precio_venta: 0,
      para_todas_cuentas: false
    },
    defaultItem: {
      id: null,
      nombre: "",
      codigo_sku: "",
      precio_costo: 0,
      precio_venta: 0,
      para_todas_cuentas: false
    },
  }),

  computed: {
    ...mapGetters(["getCurrentAccountId"]),

    filteredItems() {
      if (this.alcanceFiltro === "global") return this.items.filter(i => i.cuenta_id === 0);
      if (this.alcanceFiltro === "cuenta") return this.items.filter(i => i.cuenta_id !== 0);
      return this.items;
    },

    globalCount() {
      return this.items.filter(i => i.cuenta_id === 0).length;
    },

    localCount() {
      return this.items.filter(i => i.cuenta_id !== 0).length;
    },

    profitMargin() {
      const cost = this.editedItem.precio_costo || 0;
      const sale = this.editedItem.precio_venta || 0;
      if (cost === 0 || sale === 0) return 0;
      return ((sale - cost) / cost) * 100;
    }
  },

  created() {
    this.getItems();
    this.debouncedGetItems = debounce(() => {
      this.pagination.page = 1;
      this.getItems();
    }, 500);
  },

  watch: {
    getCurrentAccountId() {
      this.pagination.page = 1;
      this.getItems();
    },
    createDialog(val) {
      if (!val) {
        this.priceCostInput = "";
        this.priceSaleInput = "";
      }
    }
  },

  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return "";
      return new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(value);
    },

    formatNumber(value) {
      if (value === null || value === undefined) return "";
      return new Intl.NumberFormat("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },

    isNumberOrComma(evt) {
      const charCode = evt.which ?? evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 44) {
        evt.preventDefault();
      }
    },

    onPriceInput(value, field) {
      if (!value) { this.editedItem[field] = 0; return; }
      const clean = value.replace(/\./g, "").replace(",", ".");
      this.editedItem[field] = parseFloat(clean) || 0;
    },

    formatOnBlur(field) {
      const val = this.editedItem[field];
      if (field === "precio_costo") this.priceCostInput = val ? this.formatNumber(val) : "";
      if (field === "precio_venta") this.priceSaleInput = val ? this.formatNumber(val) : "";
    },

    clearFilter(field) {
      this.filters[field] = "";
      this.pagination.page = 1;
      this.getItems();
    },

    getItems() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        limit: this.options.itemsPerPage,
        cuenta_id: this.getCurrentAccountId,
        ...this.filters
      };
      if (!params.nombre) delete params.nombre;
      if (!params.codigo_sku) delete params.codigo_sku;

      Productos.getProductos(params)
        .then(response => {
          let data = response.data.data || response.data.Data;
          if (data) {
            this.items = data.data || [];
            const meta = data.meta && data.meta.page ? data.meta.page : {};
            this.pagination.page = meta.currentPage || 1;
            this.pagination.lastPage = meta.lastPage || 1;
            this.pagination.total = meta.total || 0;
          } else {
            this.items = [];
            this.pagination.total = 0;
          }
        })
        .catch(error => {
          console.error(error);
          this.errored = true;
          this.$toastr.e("Error al cargar los productos");
        })
        .finally(() => { this.loading = false; });
    },

    onPageChange(page) {
      this.pagination.page = page;
      this.getItems();
    },

    updateRowsPerPage(n) {
      this.options.itemsPerPage = n;
      this.pagination.page = 1;
      this.getItems();
    },

    openCreateDialog() {
      this.editing = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.priceCostInput = "";
      this.priceSaleInput = "";
      this.createDialog = true;
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.resetValidation(); });
    },

    closeCreateDialog() {
      this.createDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.priceCostInput = "";
        this.priceSaleInput = "";
        this.editing = false;
      });
    },

    editItem(item) {
      this.editing = true;
      this.editedItem = Object.assign({}, item);
      this.editedItem.para_todas_cuentas = item.cuenta_id === 0;
      this.priceCostInput = this.formatNumber(item.precio_costo);
      this.priceSaleInput = this.formatNumber(item.precio_venta);
      this.createDialog = true;
    },

    async saveItem() {
        if (!this.$refs.form.validate()) return;
        
        this.processing = true;
        try {
             const payload = {
                cuenta_id: parseInt(this.getCurrentAccountId),
                nombre: this.editedItem.nombre,
                precio_venta: parseFloat(this.editedItem.precio_venta),
                precio_costo: parseFloat(this.editedItem.precio_costo),
                codigo_sku: this.editedItem.codigo_sku
            };
            
            if (this.editing) {
                payload.id = this.editedItem.id;
                await Productos.updateProducto(payload);
                this.$toastr.s("Producto actualizado correctamente");
            } else {
                await Productos.createProducto(payload);
                this.$toastr.s("Producto creado correctamente");
            }
            this.closeCreateDialog();
            this.getItems();
        } catch (error) {
            console.error(error);
            const msg = error.response && error.response.data && error.response.data.message 
                        ? error.response.data.message 
                        : "Ocurrió un error al guardar";
            this.$toastr.e(msg);
        } finally {
            this.processing = false;
        }
    },

    async toggleActivo(item) {
      const nuevoEstado = !item.activo;
      try {
        await Productos.toggleActivoProducto(item.id, nuevoEstado);
        // Actualización optimista para evitar recargar la tabla completa
        this.$set(item, "activo", nuevoEstado);
        this.$toastr.s(`Producto ${nuevoEstado ? "activado" : "desactivado"} correctamente`);
      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.message ?? "Error al cambiar el estado del producto";
        this.$toastr.e(msg);
      }
    },

    async deleteItem(item) {
      const { isConfirmed } = await this.$swal.fire({
        title: "¿Eliminar producto?",
        text: `"${item.nombre}" será eliminado permanentemente.`,
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, eliminar",
        denyButtonText: "Cancelar",
      });
      if (!isConfirmed) return;
      try {
        await Productos.deleteProducto(item.id);
        this.$toastr.s("Producto eliminado correctamente");
        this.getItems();
      } catch (error) {
        console.error(error);
        const msg = error.response?.data?.message ?? "Error al eliminar producto";
        this.$toastr.e(msg);
      }
    }
  }
};
</script>

<style scoped>
/* Stats */
.stat-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}
.stat-value {
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1.1;
}
.stat-label {
  font-size: 0.78rem;
  color: #9e9e9e;
  margin-top: 2px;
}
.stat-icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stat-icon--primary { background-color: #1976d2; }
.stat-icon--indigo  { background-color: #3949ab; }
.stat-icon--teal    { background-color: #00796b; }

/* Row icon */
.row-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.row-icon--global { background-color: #3949ab; }
.row-icon--local  { background-color: #00796b; }

/* Badge alcance */
.badge-alcance {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #fff;
}
.badge-alcance--global { background-color: #3949ab; }
.badge-alcance--local  { background-color: #00796b; }

/* Table */
.products-table ::v-deep th {
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9e9e9e !important;
  font-weight: 600 !important;
}
.products-table ::v-deep tbody tr:hover {
  background-color: #f9f9f9 !important;
}

/* Alcance group */
.alcance-group {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
}
.alcance-btn {
  padding: 4px 12px;
  font-size: 0.78rem;
  font-weight: 500;
  color: #555;
  background: #fff;
  border: none;
  border-right: 1px solid #ccc;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.alcance-btn:last-child { border-right: none; }
.alcance-btn:hover { background: #f0f0f0; }
.alcance-btn--active {
  background: #1976d2;
  color: #fff;
  font-weight: 600;
}

/* Action buttons */
.action-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s;
}
.action-btn:hover { opacity: 0.8; }
.action-btn--edit   { background: #1976d2; }
.action-btn--delete { background: #e53935; }

/* Dialog Header */
.dialog-header {
  padding: 20px;
  border-radius: 4px 4px 0 0;
}
.dialog-header--create { background: linear-gradient(135deg, #1976d2, #42a5f5); }
.dialog-header--edit   { background: linear-gradient(135deg, #388e3c, #66bb6a); }
.dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Scope card */
.scope-card { transition: border-color 0.2s, background-color 0.2s; }
.scope-card--global { border-color: #5c6bc0 !important; background-color: #f3f4fd !important; }
.scope-card--local  { border-color: #00897b !important; background-color: #f0faf9 !important; }
.scope-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.scope-icon--global { background-color: #3949ab; }
.scope-icon--local  { background-color: #00796b; }

/* Section label */
.field-section-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #9e9e9e;
}

/* Margin card */
.margin-card {
  background-color: #fafafa !important;
  border-color: #e0e0e0 !important;
}

::v-deep .v-input__prepend-inner .v-icon { font-size: 18px !important; }
</style>
